import {
    ChangeEvent,
    Dispatch,
    SetStateAction,
    useEffect,
    useRef,
    useState,
} from "react";
import UnForm from "../../../../Components/Form";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";
import { FormProvider, useForm } from "react-hook-form";
import {
    ICustosResponse,
    IListagemDeCustos,
} from "../../../../Interfaces/AssistenciaTecnica/CustoOficialRelatoriosBI/CustoOficialRelatoriosBI";
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    AtualizacaoDeCustosController,
    CadastroDeCustosController,
    getCustosController,
} from "../../../../Controllers/AssistenciaTecnica/CustoOficialRelatoriosBI/CustoOficialRelatoriosBIController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { DatePicker } from "antd";
import moment, { Moment } from "moment";
import { ListarEstadosController } from "../../../../Controllers/Geral/CadastrarCliente/CadastrarClienteController";
import Select from "react-select";

interface ICreateUpdateCustoOficial {
    row?: IListagemDeCustos;
    setShow: Dispatch<SetStateAction<boolean>>;
    ListagemDeCustos: (...args: any[]) => Promise<ICustosResponse>;
    setFuncionario: Dispatch<SetStateAction<string | undefined>>;
    setDsPraca: Dispatch<SetStateAction<string | undefined>>;
    funcionario: string | undefined;
    praca: string | undefined;
}

export default function CreateUpdateCustoOficial(
    props: ICreateUpdateCustoOficial
) {
    const formMethods = useForm<IListagemDeCustos>();
    const { execute: CadastroDeCustos, loading: CadastroDeCustosLoading } =
        useAsyncCallback(CadastroDeCustosController);

    const [selectedOption, setSelectedOption] = useState({
        label: "",
        value: 0,
    });

    const [selectedOptionPraca, setSelectedOptionPraca] = useState({
        label: "",
        value: 0,
    });

    const {
        execute: AtualizacaoDeCustos,
        loading: AtualizacaoDeCustosLoading,
    } = useAsyncCallback(AtualizacaoDeCustosController);

    const { value: getCustos, loading: getCustosLoading } =
        useAsyncEffect(async () => {
            if (props.row) {
                const res = await getCustosController(props.row.ID);
                return res;
            }
        }, [props.row]);

    function geradorMascaraFinanceira(inputName: keyof IListagemDeCustos) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);
            formMethods?.setValue(inputName, mask);
        };
    }

    const [ano, setAno] = useState<string>(String(getCustos?.ANO ?? ""));

    function onChange(date: Moment | null, dateString: string) {
        setAno(dateString);
    }

    const [mes, setMes] = useState<string>(String(getCustos?.MES ?? ""));

    function onChangeMes(date: Moment | null, dateString: string) {
        setMes(dateString);
    }

    const funcionario = useRef<any>();
    const praca = useRef<any>();

    function handleCreateUpdateCustoOficial(formData: IListagemDeCustos) {
        if (props.row) {
            AtualizacaoDeCustos([
                {
                    ...formData,
                    ID: props.row.ID,
                    MES: mes ? mes : getCustos?.MES ?? "",
                    ANO: ano ? ano : getCustos?.ANO ?? "",
                    ID_OFICIAL_FUNCIONARIO: selectedOption.value,
                    DS_PRACA: selectedOptionPraca.label,
                },
            ]).then(() => {
                props.setDsPraca("");
                props.setFuncionario("");
                props.setShow(false);
                props.ListagemDeCustos();
            });
        } else {
            CadastroDeCustos({
                ...formData,
                MES: mes ? mes : getCustos?.MES ?? "",
                ANO: ano ? ano : getCustos?.ANO ?? "",
                ID_OFICIAL_FUNCIONARIO: selectedOption.value,
                DS_PRACA: selectedOptionPraca.label,
            }).then(() => {
                props.setDsPraca("");
                props.setFuncionario("");
                props.setShow(false);
                props.ListagemDeCustos();
            });
        }
    }

    const isLoading = CadastroDeCustosLoading || AtualizacaoDeCustosLoading;

    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    const [optionsPraca, setOptionsPraca] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const { value: lstUsuario } = useAsyncEffect(
        () => ListarUsuariosController(),
        []
    );
    const { value: lstPraca } = useAsyncEffect(
        () => ListarEstadosController(),
        []
    );
    useEffect(() => {
        setOptions(() =>
            lstUsuario?.map((empreendimento) => ({
                label: empreendimento.DS_NOME,
                value: empreendimento.ID_USUARIO,
            }))
        );
        setOptionsPraca(() =>
            lstPraca?.map((empreendimento) => ({
                label: empreendimento.DS_ESTADO,
                value: empreendimento.ID_ESTADO,
            }))
        );

        if (getCustos) {
            setSelectedOption({
                label: getCustos.DS_OFICIAL_FUNCIONARIO,
                value: getCustos.ID_OFICIAL_FUNCIONARIO,
            });

            setSelectedOptionPraca({
                label: getCustos.DS_PRACA,
                value: 0,
            });
        }
    }, [lstUsuario, lstPraca, getCustos]);

    return (
        <OrSpinner loading={getCustosLoading} spinner="capys">
            <FormProvider {...formMethods}>
                <UnForm handleSubmit={handleCreateUpdateCustoOficial}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Funcionário oficial</label>
                            <Select
                                name="ID_OFICIAL_FUNCIONARIO"
                                ref={funcionario}
                                options={options}
                                isClearable
                                value={selectedOption}
                                onChange={(e) => {
                                    const selectedValue = e
                                        ? e.label.toString()
                                        : "";
                                    props.setFuncionario(selectedValue);
                                    setSelectedOption({
                                        label: e?.label ? e.label : "",
                                        value: e?.value ? e.value : 0,
                                    });
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder=""
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>

                        <div className="col-md-6">
                            <label>Praça</label>
                            <Select
                                name="DS_PRACA"
                                ref={praca}
                                options={optionsPraca}
                                value={selectedOptionPraca}
                                isClearable
                                onChange={(e) => {
                                    props.setDsPraca(e?.label);

                                    setSelectedOptionPraca({
                                        label: e?.label ? e.label : "",
                                        value: e?.value ? e.value : 0,
                                    });
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>

                        <div className="col-md-6">
                            <UnForm.Input
                                label="Valor Final"
                                name="VL_FINAL"
                                registerOptions={{
                                    setValueAs: (v: string) => {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    },
                                    required: "Insira um valor",
                                }}
                                onChange={geradorMascaraFinanceira("VL_FINAL")}
                                defaultValue={formatMoneyReais(
                                    getCustos?.VL_FINAL ?? 0
                                )}
                            />
                        </div>

                        <div className="col-md-6">
                            <label>Mês</label>
                            <DatePicker
                                picker="month"
                                onChange={onChangeMes}
                                className="form-control"
                                defaultValue={
                                    getCustos?.MES
                                        ? moment(
                                              getCustos?.MES.toString(),
                                              "MM"
                                          )
                                        : undefined
                                }
                                placeholder=""
                                format={"MM"}
                            />
                        </div>

                        <div className="col-md-6">
                            <label>Ano</label>
                            <DatePicker
                                picker="year"
                                onChange={onChange}
                                className="form-control"
                                defaultValue={
                                    getCustos?.ANO
                                        ? moment(
                                              getCustos?.ANO.toString(),
                                              "YYYY"
                                          )
                                        : undefined
                                }
                                placeholder=""
                            />
                        </div>
                        <div className="col-md-12">
                            <UnForm.SubmitButton
                                className="w-100 mt-5"
                                type="submit"
                                color={props.row ? "primary" : "success"}
                                icon={props.row ? faEdit : faPlus}
                                wrapperClassName="w-100"
                                loading={isLoading}
                                disabled={
                                    isLoading ||
                                    (selectedOption?.label.length === 0 &&
                                        selectedOption?.value === 0) ||
                                    (selectedOptionPraca?.label.length === 0 &&
                                        selectedOptionPraca?.value === 0)
                                }
                                loadingSize={"sm"}
                            >
                                {props.row ? "Editar" : "Salvar"}
                            </UnForm.SubmitButton>
                        </div>
                    </div>
                </UnForm>
            </FormProvider>
        </OrSpinner>
    );
}
